<template>
  <div class="device-map">
    <vue-amap ref="amap" @complete="setMarkers"></vue-amap>
  </div>
</template>

<script>
import Vue from 'vue'
import VueAmap from '@/components/Amap/index.vue'

const ICONS = {
  虫情测报灯: { name: 'light', color: '#5470c6' },
  气象监测站: { name: 'water-drop', color: '#91cc75' },
  性诱诱捕器: { name: 'traps', color: '#fac858' },
  远程监控: { name: 'camera', color: '#ee6666' },
  智能孢子仪: { name: 'spores', color: '#73c0de' },
  赤霉病预警仪: { name: 'gibberella', color: '#3ba272' }
}

export default {
  components: { VueAmap },
  data() {
    return {
      width: 252
    }
  },
  computed: {
    items() {
      return this.devices.map(d => ({ ...d, icon: ICONS[d.category] }))
    },
    markers() {
      return this.items
        .filter(d => d.lat && d.lng)
        .map(d => {
          const content = this.getContent(d.icon)
          const info = this.getInfo(d)
          return { lat: d.lat, lng: d.lng, content, info }
        })
    }
  },
  mounted() {
    this.layout()
  },
  methods: {
    layout() {
      this.width = this.$el.clientWidth
    },
    getContent(icon) {
      const el = new Vue({
        render(h) {
          const content = h('svg-icon', { props: { iconClass: icon.name } })
          return h(
            'div',
            {
              class: 'amap-marker amap-marker__small',
              style: `color: ${icon.color};`,
              ref: 'node'
            },
            [content]
          )
        }
      }).$mount()
      return el.$refs.node
    },
    getInfo(device) {
      let el = document.createElement('div')
      el.className = 'amap-marker__title'
      el.innerHTML = device.name
      el.onclick = () => {
        this.$emit('change', device)
      }
      return el
    },
    setMarkers(map, AMap) {
      if (this.markers.length && this.$refs.amap) {
        this.$refs.amap.setMarkers(this.markers)
      }
      this.$nextTick(() => {
        map.setZoom(12)
        const layer = new AMap.TileLayer.RoadNet()
        map.add(layer)
        map.setFeatures(['road'])
      })
    }
  }
}
</script>

<style lang="scss">
$marker-small: 32px;
$marker-size: 14px; // 图标尺寸
$marker-text-size: 14px;
$marker-text-lineheight: 32px;
.device-map {
  background-image: url('~@/assets/images/map-bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 40px;
  height: 100%;
  box-sizing: border-box;
  // margin-bottom: 40px;
  .amap-marker__small {
    display: flex;
    width: $marker-small;
    height: $marker-small;
    border-radius: 50%;
    background: rgba(27, 43, 55, 0.8);
    align-items: center;
    justify-content: center;
  }
  .svg-icon {
    font-size: $marker-size;
    width: $marker-size;
  }
  .amap-marker__title {
    padding-left: 1rem;
    padding-right: 1rem;
    color: #f2f6fc;
    height: $marker-text-lineheight;
    line-height: $marker-text-lineheight;
    font-size: $marker-text-size;
    background-color: #1b2b37;
    border-radius: 3px;
    overflow: hidden;
    cursor: pointer;
  }
}
</style>
